// Placeholder.js
import React from 'react';

const Placeholder = ({ children }) => (
  <div id="placeholder">
    {children}
  </div>
);

export default Placeholder;
